/// InputEvent serializer: converts DOM events to serializable objects for postMessage (Phase 14).
/// Mouse, wheel, and keyboard events are captured on the host (main thread) and forwarded
/// to the render worker via postMessage. The worker passes them to C++ for hit-testing and input handling.
///
/// Plan 07: Uses offsetX/offsetY (canvas-relative) scaled by devicePixelRatio for correct
/// canvas-space coordinates. clientX/clientY would be wrong when canvas doesn't start at (0,0).

export interface InputEvent {
  kind: string;
  x: number;
  y: number;
  button: number;
  buttons: number;
  ctrlKey: boolean;
  shiftKey: boolean;
  altKey: boolean;
  deltaX?: number;
  deltaY?: number;
  key?: string;
}

/// Device pixel ratio for scaling canvas-relative coordinates
const dpr = typeof window !== "undefined" ? (window.devicePixelRatio || 1) : 1;

export function serializeMouseEvent(e: MouseEvent, kind: string): InputEvent {
  return {
    kind,
    x: e.offsetX * dpr,
    y: e.offsetY * dpr,
    button: e.button,
    buttons: e.buttons,
    ctrlKey: e.ctrlKey,
    shiftKey: e.shiftKey,
    altKey: e.altKey,
  };
}

export function serializeWheelEvent(e: WheelEvent): InputEvent {
  return {
    kind: "wheel",
    x: e.offsetX * dpr,
    y: e.offsetY * dpr,
    button: e.button,
    buttons: e.buttons,
    ctrlKey: e.ctrlKey,
    shiftKey: e.shiftKey,
    altKey: e.altKey,
    deltaX: e.deltaX,
    deltaY: e.deltaY,
  };
}

export function serializeKeyboardEvent(e: KeyboardEvent, kind: string): InputEvent {
  return {
    kind,
    x: 0,
    y: 0,
    button: 0,
    buttons: 0,
    ctrlKey: e.ctrlKey,
    shiftKey: e.shiftKey,
    altKey: e.altKey,
    key: e.key,
  };
}
